import axios from 'axios'
import { ContentTypeEnum } from '@enums/httpEnum'
import { Message, MessageBox } from 'element-ui'
import LoadingCounter from './LoadingCounter'
import store from '@/store'

const loadingCounter = new LoadingCounter()

const COM_ERR_MSG = {
  EMPTY_URL: '---url---不能为空',
}

class Request {
  constructor(options) {
    this.axio = this.createAxiosInstance(options)
  }

  createAxiosInstance(options) {
    const instance = axios.create(options)

    instance.interceptors.request.use((config) => {
      if (!config.disabledLoading) {
        loadingCounter.plus()
      }
      return config
    })

    instance.interceptors.response.use(
      (res) => {
        if (!res?.config?.disabledLoading) {
          loadingCounter.minus()
        }
        // console.log(res)

        if (res.status === 200) {
          const { data, status, message = '请求失败' } = res?.data

          const handleErrorResponse = res?.config?.handleErrorResponse || false
          if (handleErrorResponse && status !== 1) {
            Message.error(message)
            return Promise.reject()
          }
          return Promise.resolve(data || res?.data)
        }

        if (res.status === 401) {
          Message.error('未登录，请登录后重试')
          window.location.href = '#/login'
          return Promise.reject()
        }

        return Promise.reject(res)
      },
      (err) => {
        loadingCounter.minus()
        const { response } = err || {}
        const { message } = response?.data || {}
        if (response.status === 401 || response.status === 400) {
          // localStorage.removeItem('loginInfo')
          Message.error('登录超时，请重新登录')
          store.commit('user/SET_USER_INFO')
          window.location.href = '#/login'
          // MessageBox({
          //   title: '注意',
          //   message: '登录超时，请重新登录',
          //   customClass: 'confirm_msg_box',
          //   showClose: false,
          //   closeOnClickModal: false,
          //   closeOnPressEscape: false,
          //   confirmButtonText: '确认',
          //   callback: function (action) {
          //     if (action === 'confirm') {
          //       store.commit('user/SET_USER_INFO')
          //       window.location.href = '#/login'
          //       // window.location.reload()
          //     }
          //   },
          // })
          return Promise.reject(err)
        }

        Message.error(message || '接口异常，请重新再试')
        return Promise.reject(err)
      }
    )

    return instance
  }

  httpPost(url = '', data = null, config = {}) {
    if (!url) {
      console.error(COM_ERR_MSG.EMPTY_URL)
      return
    }
    return this.axio.post(url, data, config)
  }

  httpPostJson(url = '', data = {}, config = {}) {
    if (!url) {
      console.error(COM_ERR_MSG.EMPTY_URL)
      return
    }
    return this.axio.post(url, data, { ...(config || {}), ...{ headers: { 'Content-Type': ContentTypeEnum.JSON } } })
  }

  httpPostMultiForm(url = '', data = null, config = {}) {
    if (!url) {
      console.error(COM_ERR_MSG.EMPTY_URL)
      return
    }

    const newData = new FormData()
    if (data) {
      for (let key in data) {
        newData.append(key, data[key])
      }
    }

    return this.axio.post(url, data ? newData : undefined, {
      ...(config || {}),
      ...{ headers: { 'Content-Type': ContentTypeEnum.FORM_DATA } },
    })
  }

  httpGet(url = '', data = null, config = {}) {
    if (!url) {
      console.error(COM_ERR_MSG.EMPTY_URL)
      return
    }
    return this.axio.get(url, { params: data, ...config })
  }
}

export default Request
